<template>
  <v-dialog
    data-testid="routineScoringWarningDialog-dialog-warning"
    persistent
    width="500"
    :value="show"
  >
    <v-card data-testid="routineScoringWarningDialog-card-warning">
      <v-card-title
        data-testid="routineScoringWarningDialog-cardTitle-warning"
        class="h6 font-weight-bold blue-grey--text text--darken-3 mb-0"
      >
        {{ title }}
      </v-card-title>
      <v-card-subtitle
        data-testid="routineScoringWarningDialog-cardSubtitle-warning"
        class="body-1 blue-grey--text text--darken-2 mt-2 mb-0"
      >
        {{ text }}
      </v-card-subtitle>
      <v-card-actions
        class="px-6 pb-5 pt-4 d-flex justify-end align-end"
        data-testid="routineScoringWarningDialog-cardActions-warning"
      >
        <Button
          color="grey"
          data-testid="routineScoringWarningDialog-button-ok"
          plain
          :text="resolvedActionText"
          @click="$emit('close')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'

export default {
  name: 'RoutineScoringWarningDialog',

  components: {
    Button,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    actionText: {
      type: String,
      default: '',
    },
  },

  computed: {
    resolvedActionText() {
      return this.actionText || this.$t('common.button.ok')
    },
  },
}
</script>
